import { Home as HomeIcon, ClipboardCheck, TrendingUp, ShieldCheck, MessageSquare, Eye, Heart, Award, CheckCircle2 } from "lucide-react";

export const FALLBACK_TRANSFORMACOES = [
    {
        title: "Cozinha renovada",
        subtitle: "Apartamento T2 · Oeiras",
        before: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        after: "https://images.unsplash.com/photo-1714860534425-7ce04e013dec?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    },
    {
        title: "Casa de banho premium",
        subtitle: "Moradia · Cascais",
        before: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        after: "https://images.unsplash.com/photo-1763485955998-a9284d042d50?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    },
    {
        title: "Sala e acabamentos",
        subtitle: "Apartamento T3 · Lisboa",
        before: "https://images.unsplash.com/photo-1554995207-c18c203602cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        after: "https://images.unsplash.com/photo-1738168279272-c08d6dd22002?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    },
];

export const HERO_IMG = "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export const AREAS = [
    { n: "01", icon: HomeIcon, title: "Remodelações", desc: "Remodelações integrais ou parciais de apartamentos, moradias e outros imóveis. Da preparação à entrega, asseguramos a execução e coordenação das diferentes especialidades necessárias.", img: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
    { n: "02", icon: ClipboardCheck, title: "Gestão de Obra", desc: "Para quem já tem os empreiteiros ou prefere não perder tempo com coordenação. Assumimos a organização, fiscalização e gestão da obra — mantém-se com um único interlocutor que assegura a correta execução, o controlo dos prazos e a comunicação com todas as partes envolvidas — começando por si.", img: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
    { n: "03", icon: TrendingUp, title: "Valorização de Imóveis", desc: "Intervenções pensadas para melhorar o estado, funcionalidade, conforto, apresentação e potencial de um imóvel — para habitação, arrendamento ou venda.", img: "https://images.unsplash.com/photo-1738168279272-c08d6dd22002?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
];

export const PROCESS = [
    { n: "01", t: "Ouvir", d: "Percebemos o que pretende, as suas prioridades e aquilo que espera da intervenção." },
    { n: "02", t: "Analisar", d: "Visitamos o imóvel, avaliamos os trabalhos e procuramos identificar condicionantes antes de começar." },
    { n: "03", t: "Orçamentar", d: "Apresentamos uma proposta clara, com os trabalhos definidos e as respetivas condições." },
    { n: "04", t: "Preparar", d: "Planeamos materiais, especialidades, sequência dos trabalhos e preparação da obra." },
    { n: "05", t: "Executar", d: "Executamos e coordenamos os trabalhos, mantendo o cliente informado ao longo da intervenção." },
    { n: "06", t: "Entregar", d: "Verificamos os trabalhos, tratamos dos acabamentos finais, organizamos e entregamos a obra." },
];

export const CODIGO = [
    { icon: Eye, t: "Clareza.", d: "Antes de começar, procuramos que esteja claro o que vamos fazer." },
    { icon: ShieldCheck, t: "Responsabilidade.", d: "Assumimos aquilo com que nos comprometemos." },
    { icon: MessageSquare, t: "Comunicação.", d: "Mantemos o cliente informado ao longo da obra." },
    { icon: CheckCircle2, t: "Verdade.", d: "Os problemas são comunicados, não escondidos." },
    { icon: Heart, t: "Respeito.", d: "Tratamos cada imóvel com o cuidado que merece." },
    { icon: Award, t: "Excelência.", d: "Não procuramos simplesmente que fique feito. Procuramos que fique bem feito." },
];

export const ESPECIALIDADES = [
    "Demolições", "Alvenarias", "Rebocos e Estuques", "Gesso Cartonado / Pladur",
    "Pinturas", "Pavimentos", "Revestimentos", "Impermeabilizações",
    "Isolamentos Térmicos e Acústicos", "Canalização", "Eletricidade",
    "Climatização e Ar Condicionado", "Ventilação", "Carpintaria", "Serralharia",
    "Caixilharia", "Vidros", "Estores", "Coberturas e Telhados", "Fachadas",
    "Cozinhas", "Casas de Banho", "Microcimento e Revestimentos Contínuos",
];
